<template>
  <div class="sidebar-container">
    <el-menu :default-active="$route.path" class="el-menu-vertical" background-color="#2d3037" text-color="#bebec0" active-text-color="#fff" :collapse="isCollapse">
      <SideBarItem v-for="item in menu" ref="sidebaritem" :key="item.path" :item="item" />
    </el-menu>
    <div class="sidebar-bottom">
      <div class="sidebar-collapse">
        <img class="collapse-button" src="@/assets/images/collapse_white.png" alt="" @click="toggleSideBarClick" />
      </div>
    </div>
  </div>
</template>

<script>
import SideBarItem from "./Common-SideBarItem"
export default {
  name: "SideBar",
  components: {
    SideBarItem
  },
  data() {
    return {
      //currentActive: "/"
    }
  },
  computed: {
    menu() {
      //console.log(this.$store.getters.routers)
      //可用this.$store访问到全局的store并获取属性
      return this.$store.getters.routers
    },
    // hasChildrenMenu() {
    //如果使用计算属性，则为可能显示出层级关系，按顺序，按层级显示
    //   return this.$store.state.user.menu.filter(function(item) {
    //     return item.children == null
    //   })
    // },
    isCollapse() {
      return this.$store.state.login.isCollapse
    }
  },

  created() {
    //this.getActiveIndex()
    console.log(this.menu)
  },
  methods: {
    // handleMenuClick(item) {
    //   console.log(item.path)
    //   //this.$store.commit("keepCurrentIndex", item.path)
    //   //this.$router.push({ path: item.path })
    // },
    toggleSideBarClick() {
      //this.isCollapse = !this.isCollapse
      this.$store.commit("toggleSideBar")
    }
    // getActiveIndex() {
    //   this.currentActive = window.location.href.split("#")[1]
    // }
  }
}
</script>

<style lang="scss">
.sidebar-container {
  height: 100%;
  position: relative;
  .el-menu {
    //@at-rootheight: calc(100% - 48px);
    // height: 100%;
    //height: calc(100% - 48px);
    //border: 1px solid red;
    padding-top: 40px;
    .el-menu {
      padding-top: 0;
      overflow: hidden;
    }
  }
  .el-menu-vertical {
    height: 100%;
    overflow: auto;
  }
  .el-menu-vertical:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .sidebar-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 48px;
    .sidebar-collapse {
      position: relative;
      height: 48px;
      .collapse-button {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        padding: 18px 20px;
      }
    }
  }
}
.el-menu-item {
  height: 50px;
  line-height: 50px;
  border-left: 2px solid #2d3037;
  &.is-active {
    border-left: 2px solid #3e84e9;
    background-color: #454e57 !important;
    box-sizing: border-box;
  }
}
</style>
